import PropTypes from 'prop-types'
import React from 'react'

import VisionProductCard from 'components/VisionProductCard'

const ProductList = ({
  currentProduct,
  isUpdating,
  visionProducts = [],
  toggleVisionProduct,
  coveredPersons,
  excludedPersons,
  isAddingBenefit,
}) => (
  <div>
    {isUpdating && <p className="layout-muted-text">Retrieving vision products...</p>}
    {visionProducts.map((product) => {
      const data = { ...product }
      data.isAddingBenefit =
        currentProduct && currentProduct.BenefitPublicKey === data.BenefitPublicKey
          ? isAddingBenefit
          : false
      data.coveredPersons = coveredPersons
      data.excludedPersons = excludedPersons
      data.added = currentProduct && currentProduct.BenefitPublicKey === data.BenefitPublicKey
      data.productOnClick = toggleVisionProduct

      return <VisionProductCard key={product.BenefitPublicKey} {...data} />
    })}
  </div>
)

ProductList.displayName = 'ProductList'
ProductList.propTypes = {
  currentProduct: PropTypes.object,
  isUpdating: PropTypes.bool,
  visionProducts: PropTypes.array,
  toggleVisionProduct: PropTypes.func,
  coveredPersons: PropTypes.array,
  excludedPersons: PropTypes.array,
  isAddingBenefit: PropTypes.bool,
}

ProductList.defaultProps = {
  currentProduct: {},
  isUpdating: false,
  visionProducts: [],
  toggleVisionProduct: null,
  coveredPersons: [],
  excludedPersons: [],
  isAddingBenefit: false,
}

export default ProductList
